// 시트 거울 화면의 작은 표시(2026-10-23) — 인바운드 현황 · 도입 문의 현황이 같이 쓴다.

import { Icon, type IconName } from '@/components/Icon';

/** 글씨 크기만 한 표시(2026-10-23 오너 "글씨크기만한걸로") */
export const MARK_SIZE = 12;

/**
 * 문의 방법 표시 — 메타는 메타 심볼(무한 고리), 웹사이트는 우리 홈페이지 심볼
 * (홈페이지 파비콘과 같은 파란 X — public/logo-monogram-homepage.svg). 그 밖은 없음.
 */
export function MethodMark({ method }: { method: string }) {
  if (method === '메타')
    return (
      <svg
        width={MARK_SIZE}
        height={MARK_SIZE}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#0866ff"
        strokeWidth={2.6}
        strokeLinecap="round"
        aria-hidden
        style={{ flexShrink: 0 }}
      >
        <path d="M12 12c-1.6-2.8-3.4-5-5.3-5C4.6 7 3 9.4 3 12.2 3 14.8 4.4 17 6.4 17c2.2 0 3.8-2.6 5.6-5s3.4-5 5.6-5c2 0 3.4 2.2 3.4 4.8 0 2.8-1.6 5.2-3.7 5.2-1.9 0-3.7-2.2-5.3-5z" />
      </svg>
    );
  if (method === '웹사이트')
    return (
      <img
        src="/logo-monogram-homepage.svg"
        width={MARK_SIZE}
        height={MARK_SIZE}
        alt=""
        style={{ flexShrink: 0, borderRadius: 2 }}
      />
    );
  const other = METHOD_ICONS[method.replace(/\s+/g, '')];
  return other ? (
    <Icon name={other[0]} size={MARK_SIZE} color={other[1]} strokeWidth={2.25} />
  ) : null;
}

/**
 * 그 밖의 문의 방법(2026-10-23 오너 "전화랑 소개서도 … 적절한 아이콘") — 전화는 수화기(초록),
 * 소개서는 내려받기(소개서 다운로드 문의, 호박색). 카톡 · 메일이 생겨도 알아보게 같이 둔다.
 */
const METHOD_ICONS: Record<string, readonly [IconName, string]> = {
  전화: ['phone', '#11734b'],
  소개서: ['download', '#b07d00'],
  카톡: ['message', '#8a6d00'],
  카카오톡: ['message', '#8a6d00'],
  메일: ['mail', '#5b6b7f'],
  이메일: ['mail', '#5b6b7f'],
};

/**
 * 도입 문의 요약 '연락 여부' 칸 표시(2026-10-23 오너 "각각에 맞는 아이콘으로") — 통화 · 부재 · 재통화 · 콜백 ·
 * 카톡회신. 색은 시트 칸 색(통화 초록 · 부재 주황)을 글씨에 읽히게 조금 어둡게, 없으면 옅은 글씨색.
 */
const CONTACT_ICONS: Record<string, IconName> = {
  통화: 'phone',
  부재: 'phone-off',
  재통화: 'refresh',
  콜백: 'phone-in',
  카톡회신: 'message',
};
export function ContactMark({ label, color }: { label: string; color?: string }) {
  const name = CONTACT_ICONS[label.replace(/\s+/g, '')];
  if (!name) return null;
  return (
    <Icon
      name={name}
      size={MARK_SIZE}
      color={color ? `color-mix(in srgb, ${color} 70%, #000)` : 'var(--fg-subtle)'}
    />
  );
}
